<script>
import jQuery from 'jquery';

import {
    onMount
} from "svelte";

onMount(() => {
	console.log(jQuery("#about"));

	function remove() {
	jQuery("#about").removeClass("hidden");
		}
	
	setTimeout(remove, 1000);
	});
</script>

<div id="about" class="hidden">
	<div>
		<img class="img rounded my-4 img-fluid" alt="About.gif" src="./img/gif/about.gif">
	</div>

	<div class="text-start mt-4 text">
		Colors represent the average color in a frame of a movie, for all frames extracted every 5 seconds.<br><br>
	</div>


	<div>
		<p class="mx-auto text-start">
		Images extracted with <span class="font-monospace">ffmpeg</span><br>
		Average color computed in <span class="font-monospace">python</span><br>
		Visualization in <span class="font-monospace">d3.js</span> & <span class="font-monospace">p5.js</span><br>
		Developped with <span class="font-monospace">svelte.js</span><br>
		Deployed with <span class="font-monospace">vercel</span><br>
		</p>
	</div>
	<div class="mt-5">
		<p class="lm text-center mx-auto">
		by Loris Mat
		</p>
		<p class="text-center mx-auto">
		<a href="https://www.lorismat.com/" target=_blank>Portfolio</a> | <a href="https://twitter.com/lorismat_" target=_blank>Twitter</a>
		</p>
		<p class="text-end copyright text-muted m-0 mt-5">
		© 2021 - Colors in Film
		</p>
	</div>

	<!--
		<div class="my-3">
			<button class="btn">Buy on Etsy</button>
		</div>
	-->
</div>

<style>
.copyright {
	max-width: none;
}
.lm {
	padding: 0px;
	margin: 3px;
}
a {
	margin-top: 3px;
	font-weight: 700;
	padding: 5px 2px;
	text-decoration: none;
	color: #000;
	box-shadow: 0px -5px inset #000;
}

a:hover {
	color: #fff;
	background-color: #000;
}

.hidden {
	visibility: hidden;
}

.font-monospace {
	font-weight: 700;
}

p {
	max-width: 300px;
}

.text {
	max-width: 300px;
	margin: 0 auto;
}
.img {
	border: 2px solid #000;
}

</style>
